import { h, Component } from 'preact'

function preloadImage(url, callback) {
    var img = new Image()
    img.src = url
    img.onload = callback
}

const stop = e => e.preventDefault()

export default class extends Component {
    constructor(props) {
        super(props)

        this.state = {
            current: this.props.src,
            next: this.props.src,
            currentHidden: false,
            nextHidden: true
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        for (var key in nextState) {
            if (nextState[key] != this.state[key]) return true
        }

        return false
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.next != nextProps.src) {
            this.loadImage(nextProps.src)
        }
    }

    loadImage (url) {
        this.loading = url
        this.setState({
            next: url,
            nextHidden: true
        })
        preloadImage(url, () => {
            if (this.loading != url) return
            this.setState({
                currentHidden: true,
                nextHidden: false
            })

            setTimeout(() => {
                if (this.loading != url) return
                this.setState(({next}) => ({
                    current: next,
                    currentHidden: false,
                    nextHidden: true
                }))
                this.loading = ''
            }, 400)
        })
    }

    render (props, {current, next, currentHidden, nextHidden}) {
        return (
            <div class={'limba__fading-image ' + props.class}>
                <img draggable="false" onDragStart={stop} class={'limba__fading-image-current ' + (currentHidden ? 'hidden-opacity' : '')} src={current} />
                <img draggable="false" onDragStart={stop} class={'limba__fading-image-next ' + (nextHidden ? 'hidden-opacity' : '')}  src={next} />
                {props.children}
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./js/components/FadingImage.js